import * as types from '../actions/action-types';

export function showAlertWithMessage(alert) {
  return {
    type: types.ALERT_WITH_MESSAGE,
    alert
  };
}
export function hideAlert(alert) {
  return {
    type: types.ALERT_HIDE,
    alert
  };
}

export function openChatGroup(group) {
  return {
    type: types.OPEN_CHATGROUP,
    group
  };
}
export function onMessageReceive(data) {
  return {
    type: types.MESSAGE_RECEIVE,
    data
  };
}
export function onCvstChange(data) {
  return {
    type: types.CVST_CHANGED,
    data
  };
}

export function refreshMessageList(data) {
  return {
    type: types.REFRESH_MSG,
    data
  };
}
export function refreshNotiList(data) {
  return {
    type: types.REFRESH_NOTI,
    data
  };
}
export function refreshChatSideBar(data) {
  return {
    type: types.REFRESH_SIDEBAR,
    data
  };
}




/** WEBPACK FOOTER **
 ** ./src/client/app/actions/common-actions.js
 **/